import { waitForElement } from './helpers.js';
import Alpine from 'alpinejs';

waitForElement('.shopify_subscriptions_app_container').then((element) => {
  const target = document.querySelector("div[id*='product_add_to_cart_button']");

  if (target) {
    let params = location.search.split('&');
    if (params.includes('subscribe=true')) {
        element.querySelector('input[data-radio-type="selling_plan"]').checked = true;
    }
    
    const quantityInputParent = target.querySelector('section > div:first-child');

    if (quantityInputParent) {
      quantityInputParent.style.display = 'none';
    }

    let sellingPlan = Alpine.reactive({
      id: element.querySelector('input[data-radio-type="selling_plan"]:checked')?.getAttribute("data-selling-plan-id")
    })

    // grab a reference to the product and variant data
    const product = Alpine.raw(Alpine.store('product'));
    const variant = product
      .variants
      .find((variant) => variant.id == Alpine.store('variant').id);

    // default the selected selling plan id
    Alpine.store('product').selected_selling_plan_id = sellingPlan.id;

    // Update the price when the selling plan changes, or reset.
    Alpine.effect(() => {
      let updatedPrice = variant.price;
      let updatedCompareAtPrice = variant.compare_at_price;
      let updatedSellingPlanId = undefined;
      
      if (sellingPlan.id) {
        let selectedSellingPlan = product
          .variants
          .find((variant) => variant.id == Alpine.store('variant').id)
          .selling_plan_allocations
          .find((plan => plan.selling_plan_id == sellingPlan.id));

          if (selectedSellingPlan) {
            updatedPrice = selectedSellingPlan.price;
            updatedCompareAtPrice = selectedSellingPlan.compare_at_price;
            updatedSellingPlanId = selectedSellingPlan.selling_plan_id;
          }
      }

      Alpine.store('variant').price = updatedPrice;
      Alpine.store('variant').compare_at_price = updatedCompareAtPrice;
      Alpine.store('product').selected_selling_plan_id = updatedSellingPlanId;

      quantityInputParent.style.display = updatedSellingPlanId ? 'none' : 'block';

      if (updatedSellingPlanId) { 
        quantityInputParent.querySelector('input').value = 1;
      }
    });

    // Listen out for changes to the subscription radios
    element.addEventListener('click', (event) => {
      setTimeout(() => {
        sellingPlan.id = element.querySelector('input[data-radio-type="selling_plan"]:checked')?.getAttribute('data-selling-plan-id') || null;
      }, 50);
    });
  }
});